import { required } from '@ps/web-shared-validators';
import React from 'react';
import { useField } from 'react-final-form';
import { useSelector } from 'react-redux';

import { select } from '@swf/core/store';

import DocumentNumberField from '../../../../../RMFDocumentation/components/DocumentNumberField/DocumentNumberField';
import DocumentTypeField from '../../../../../RMFDocumentation/components/DocumentTypeField/DocumentTypeField';

import {
  TXTWCL_Document_number,
  TXTWCL_Please_enter_your_identificati_ELL_1
} from './GenericFields.messages.json';

const GenericFields: React.FC = () => {
  const signupCountry = useSelector(select.account.getCountry);

  const {
    input: { value: country }
  } = useField('country', { initialValue: signupCountry });

  const {
    input: { value: docType }
  } = useField('docType', { subscription: { value: true } });

  const {
    input: { value: docNumber }
  } = useField('docType', { subscription: { value: true } });

  const {
    input: { value: citizenship }
  } = useField('citizenship', { subscription: { value: true }, initialValue: signupCountry });

  return (
    <>
      <DocumentTypeField country={country} citizenship={citizenship} />
      <DocumentNumberField
        label={TXTWCL_Document_number}
        maxLength={30}
        validator={[required(TXTWCL_Please_enter_your_identificati_ELL_1)]}
      />
    </>
  );
};

export default GenericFields;
